import guest from './rules/guest';
import user from './rules/user';
import clientOfAffiliate from './rules/clientOfAffiliate';
import checkAffiliate from './rules/checkAffiliate';

export default {
    guest, user, clientOfAffiliate, checkAffiliate
}